import { LocaleText } from '../AppProvider';

import { getLocalization } from './getLocalization';

const hiINLabels: Partial<LocaleText> = {
  or: 'या',
  to: 'को',

  ok: 'ठीक है',
  // Common authentication labels
  email: 'ईमेल',

  // Common action labels
  save: 'सहेजें',
  with: 'के साथ',
  alert: 'सूचना',
  delete: 'हटाएं',

  passkey: 'पासकी',
  close: 'बंद करें',
  password: 'पासवर्ड',
  cancel: 'रद्द करें',

  confirm: 'पुष्टि करें',
  username: 'उपयोगकर्ता नाम',
  // AccountPreview
  accountPreviewTitle: 'खाता',
  loading: 'लोड हो रहा है...',
  signInRememberMe: 'मुझे याद रखें',
  // Account
  accountSignInLabel: 'साइन इन करें',
  accountSignOutLabel: 'साइन आउट करें',
  accountPreviewIconButtonLabel: 'वर्तमान उपयोगकर्ता',
  providerSignInTitle: (provider: string) => `${provider} से साइन इन करें`,
  signInSubtitle: 'स्वागत है उपयोगकर्ता, कृपया जारी रखने के लिए साइन इन करें',
  // SignInPage
  signInTitle: (brandingTitle?: string) =>
    brandingTitle ? `${brandingTitle} में साइन इन करें ` : `साइन इन करें`,
};

export default getLocalization(hiINLabels);
